import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const teamWebhooksPageReducer = (state = initialState.teamWebhooksPage, action) => {
  switch (action.type) {
    case actionTypes.teamWebhooksPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default teamWebhooksPageReducer;
